import React from 'react'
import styled, { keyframes } from 'styled-components'

const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Block = styled.div`
  position: absolute;
  width: ${({ width }) => (width ? `${width}px` : '38px')};
  height: ${({ height }) => (height ? `${height}px` : '22px')};

  &:nth-of-type(2) {
    transform: rotate(60deg);
  }

  &:nth-of-type(3) {
    transform: rotate(-60deg);
  }
`

const InnerDiv = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const Span = styled.span`
  position: absolute;
  width: 3px;
  height: 0;
  background: var(--grey);
  background: ${({ color }) => (color ? `var(--${color})` : 'var(--grey)')};
  width: ${({ small }) => (small ? '2px' : '3px')};
  z-index: 999999;
`

const animateLoad1 = keyframes`
    0% {
        bottom: 0;
        height: 0;
    }
    6.944444444% {
        bottom: 0;
        height: 100%;
    }
    50% {
        top: 0;
        height: 100%;
    }
    59.944444433% {
        top: 0;
        height: 0;
    }
`

const animateLoad2 = keyframes`
    0% {
        top: 0;
        height: 0;
    }
    6.944444444% {
        top: 0;
        height: 100%;
    }
    50% {
        bottom: 0;
        height: 100%;
    }
    59.944444433% {
        bottom: 0;
        height: 0;
    }
`

const animateLoad3 = keyframes`
    0% {
        top: 0;
        height: 0;
    }
    6.944444444% {
        top: 0;
        height: 100%;
    }
    50% {
        bottom: 0;
        height: 100%;
    }
    59.94444443% {
        bottom: 0;
        height: 0;
    }
`

const animateLoad4 = keyframes`
    0% {
        top: 0;
        height: 0;
    }
    6.944444444% {
        top: 0;
        height: 100%;
    }
    50% {
        bottom: 0;
        height: 100%;
    }
    59.94444443% {
        bottom: 0;
        height: 0;
    }
`

const animateLoad5 = keyframes`
    0% {
        bottom: 0;
        height: 0;
    }
    6.944444444% {
        bottom: 0;
        height: 100%;
    }
    50% {
        top: 0;
        height: 100%;
    }
    59.94444443% {
        top: 0;
        height: 0;
    }
`

const animateLoad6 = keyframes`
    0% {
        bottom: 0;
        height: 0;
    }
    6.944444444% {
        bottom: 0;
        height: 100%;
    }
    50% {
        top: 0;
        height: 100%;
    }
    59.94444443% {
        top: 0;
        height: 0;
    }
`

const Wrap1 = styled(Span)`
  left: 0;
  animation: ${animateLoad1} 3.6s ease infinite;
`

const Wrap2 = styled(Span)`
  right: 0;
  animation: ${animateLoad2} 3.6s ease 0.3s infinite;
`

const Wrap3 = styled(Span)`
  right: 0;
  animation: ${animateLoad3} 3.6s ease 0.6s infinite;
`

const Wrap4 = styled(Span)`
  right: 0;
  animation: ${animateLoad4} 3.6s ease 0.9s infinite;
`

const Wrap5 = styled(Span)`
  left: 0;
  animation: ${animateLoad5} 3.6s ease 1.2s infinite;
`

const Wrap6 = styled(Span)`
  left: 0;
  animation: ${animateLoad6} 3.6s ease 1.5s infinite;
`

const LoaderHexagon = ({ width, height, color, small, className = '' }) => {
  return (
    <Container className={className}>
      <Block width={width} height={height}>
        <InnerDiv>
          <Wrap6 small={small} color={color} className="one" />
          <Wrap3 small={small} color={color} className="two" />
        </InnerDiv>
      </Block>
      <Block width={width} height={height}>
        <InnerDiv>
          <Wrap1 small={small} color={color} className="one" />
          <Wrap4 small={small} color={color} className="two" />
        </InnerDiv>
      </Block>
      <Block width={width} height={height}>
        <InnerDiv>
          <Wrap5 small={small} color={color} className="one" />
          <Wrap2 small={small} color={color} className="two" />
        </InnerDiv>
      </Block>
    </Container>
  )
}

export default LoaderHexagon
